<div class="success">
  <h1>Email successfully verified!</h1>
  <h3>You are now able to <a href="/login">login</a></h3>
</div>
